/**
 * Created by daniel on 23/04/17.
 */

export const CREATE_CONTENT_ITEM = "CREATE_CONTENT_ITEM";
export const DELETE_CONTENT_ITEM = "DELETE_CONTENT_ITEM";
export const ORPHAN_CONTENT_ITEM = "ORPHAN_CONTENT_ITEM";
export const RESTORE_ORPHANED_CONTENT_ITEM = "RESTORE_ORPHANED_CONTENT_ITEM";
export const MOVE_CONTENT_ITEM = "MOVE_CONTENT_ITEM";
export const UPDATE_CONTENT_ITEM = "UPDATE_CONTENT_ITEM";
export const HIDE_CONTENT_ITEM = "HIDE_CONTENT_ITEM";
export const SET_CONTENT_ITEMS = "SET_CONTENT_ITEMS";

/** Create a new content item
 * @param contentParentId
 * @param relativeToContentId
 * @param configId
 * @param contentDefs
 * @param moveBelow
 * @return {{type: string, contentParentId: *, relativeToContentId: *, configId: *, contentDefs: *}}
 */
export function createContentItem(contentParentId, relativeToContentId, configId, contentDefs, moveBelow) {
  return {
    type: CREATE_CONTENT_ITEM,
    contentParentId,
    relativeToContentId,
    configId,
    contentDefs,
    moveBelow,
  }
}

export function deleteContentItem(contentId) {
  return {
    type: DELETE_CONTENT_ITEM,
    contentId,
  }
}

export function orphanContentItem(contentId) {
  return {
    type: ORPHAN_CONTENT_ITEM,
    contentId,
  }
}

export function restoreOrphanedContentItem(contentId) {
  return {
    type: RESTORE_ORPHANED_CONTENT_ITEM,
    contentId,
  }
}

/**
 * Moves the specified item to the specified parent, above the specified child.
 *
 * @param {string} contentId
 * @param {string} contentParentId
 * @param {string} relativeToContentId
 * @param {boolean} moveBelow
 */
export function moveContentItem(contentId, contentParentId, relativeToContentId, moveBelow) {
  return {
    type: MOVE_CONTENT_ITEM,
    contentId,
    contentParentId,
    relativeToContentId,
    moveBelow,
  }
}
/**
 * Lazily updates stored state of item. Only updates is data changed, and does not save anything
 * matching its default value.
 *
 * @param {string} contentId
 * @param {Object} newProps Subset of item props. Will be merged into oldProps below.
 * @param {Object} oldProps Current calculated props prior to the change.
 * @param {Object} defaultProps
 * @returns {{type: string, itemId: *, newProps: *, oldProps: *, defaultProps: *}}
 */
export function updateContentItem(contentId, newProps, oldProps, defaultProps) {
  return {
    type: UPDATE_CONTENT_ITEM,
    contentId,
    newProps,
    oldProps,
    defaultProps,
  }
}

/**
 * Toggle visibility of a content item
 * @param contentId
 * @param {boolean} contentHidden
 * @return {{type: string, hideItem: boolean}}
 */
export function hideContentItem(contentId, contentHidden) {
  return {
    type: HIDE_CONTENT_ITEM,
    contentId,
    contentHidden
  }
}

/**
 * Set the current contentItem state - used to initialise the editor
 * @param {Array} content
 * @returns {{type: string, content: *}}
 */
export function setContentItems(content) {
  return {
    type: SET_CONTENT_ITEMS,
    content,
  }
}


// WEBPACK FOOTER //
// ./src/App/Editor/state/content/actions.js